class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
        	
      });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);


document.addEventListener("DOMContentLoaded", function () {
    const specialProductHandle = "duo-combo-white-shirt"; // Change this to your special product handle
  
    // Event delegation for dynamically loaded cart items
    document.body.addEventListener("click", function (event) {
        if (event.target.classList.contains("plus") || event.target.classList.contains("minus")) {
            const cartItem = event.target.closest(".cart-item");
            if (!cartItem) return;

            const quantityInput = cartItem.querySelector(".cart-quantity");
            const productHandle = cartItem.getAttribute("data-product-handle");
            const itemId = cartItem.getAttribute("data-id");
            let currentValue = parseInt(quantityInput.value) || 1;

            // Determine increment/decrement value
            let changeValue = (productHandle === specialProductHandle) ? 2 : 1;

            if (event.target.classList.contains("plus")) {
                quantityInput.value = currentValue + changeValue;
            } else {
                let newValue = currentValue - changeValue;
                quantityInput.value = (newValue >= changeValue) ? newValue : changeValue; // Prevents going below minimum
            }

            // Update Shopify cart via AJAX
            updateCart(itemId, quantityInput.value);
        }
    });

    function updateCart(itemId, newQuantity) {
        fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: itemId, quantity: newQuantity }),
        })
        .then(response => response.json())
        .then(cart => {
            document.dispatchEvent(new Event("cart:updated")); // Refresh cart UI
        })
        .catch(error => console.error("Error updating cart:", error));
    }

    // Ensure the cart UI updates after Shopify updates the cart
    document.addEventListener("cart:updated", function () {
        fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                cart.items.forEach(item => {
                    let cartItem = document.querySelector(`.cart-item[data-id="${item.id}"]`);
                    if (cartItem) {
                        let quantityInput = cartItem.querySelector(".cart-quantity");
                        quantityInput.value = item.quantity; // Sync UI with backend
                    }
                });
            })
            .catch(error => console.error("Error refreshing cart:", error));
    });
});
